/**
 * ============================================================================
 * USER / TENANT SERVICE: Contacts & Audience Groups (Sheets 25 & 28)
 * ============================================================================
 * Purpose:
 *   Handles customer audience records (`tbl_contacts`) and contact groups
 *   (`tbl_groups`) scoped to the active tenant's private database.
 *
 * Database Scope:
 *   Tenant Database (`digi_user_<id>`)
 * ============================================================================
 */

import api from "../../core/services/api";
import { createCrudService } from "../../core/services/crudServiceFactory";

const baseContactService = createCrudService("tenant/contacts");
const baseGroupService = createCrudService("tenant/groups");

const groupService = {
  ...baseGroupService,
  getContacts: (groupId) => {
    return api.get(`/tenant/groups/${groupId}/contacts`);
  },
};

const contactService = {
  ...baseContactService,
  groups: groupService,

  /**
   * Bulk imports customer contacts from CSV/Excel data array.
   *
   * @param {Array<Object>} contactsList
   * @param {string} [groupId]
   * @returns {Promise<Object>} Import summary
   */
  bulkImport: (contactsList, groupId = "") => {
    return api.post("/tenant/contacts/bulk-import", { contacts: contactsList, groupId });
  },

  getContactsByGroup: (groupId) => {
    return api.get(`/tenant/groups/${groupId}/contacts`);
  },
};

export default contactService;
